// @flow
import { connect } from 'react-redux'
import type { Store } from '../../redux/ducks'
import { patch } from '../../redux/ducks/leadformEdit/reducers'
import Questions, { type Props } from './Questions'
import type { LeadformCustomQuestion, LeadformStockQuestions } from '../types'
import store from '../../redux/store'
import _ from 'lodash'

function mapStateToProps(state: Store) {
  const { stockQuestions, questions: customQuestions } = state.leadformEdit

  return { stockQuestions, customQuestions }
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onStockQuestionsChange: (stockQuestions: LeadformStockQuestions) => {
      dispatch(patch({ stockQuestions: stockQuestions }))
    },
    onCustomQuestionAdd: () => {
      const questions = store.getState().leadformEdit.questions
      dispatch(patch({ questions: [...questions, { type: 'input', title: '' }] }))
    },
    onCustomQuestionRemove: (index: number) => {
      const questions = _.cloneDeep(store.getState().leadformEdit.questions)
      questions.splice(index, 1)
      dispatch(patch({ questions }))
    },
    onCustomQuestionChange: (index: number, value: LeadformCustomQuestion) => {
      const questions = _.cloneDeep(store.getState().leadformEdit.questions)
      questions[index] = value
      dispatch(patch({ questions }))
    }
  }
}

const QuestionsContainer = connect<Props, {||}, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(Questions)

export default QuestionsContainer
